import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import SignalsManagementButton from "../SignalsManagementButton/SignalsManagementButton";

import {
    StyledSignalsPromoBannerButton,
    StyledSignalsPromoBannerContent,
    StyledSignalsPromoBannerImage,
    StyledSignalsPromoBannerSubtitle,
    StyledSignalsPromoBannerTitle,
    StyledSignalsPromoBannerWrapper,
} from "./styles";

const SignalsPromoBanner = () => (
    <StyledSignalsPromoBannerWrapper>
        <StyledSignalsPromoBannerImage src={AssetsService.assetUrl("/images/sales-intelligence/signals-promo.svg")} />
        <StyledSignalsPromoBannerContent>
            <StyledSignalsPromoBannerTitle data-automation="signals-promo-title">
                {translate("si.account-overview.signals.banner.title")}
            </StyledSignalsPromoBannerTitle>
            <StyledSignalsPromoBannerSubtitle data-automation="signals-promo-subtitle-1">
                {translate("si.account-overview.signals.banner.subtitle1")}
            </StyledSignalsPromoBannerSubtitle>
            <StyledSignalsPromoBannerSubtitle data-automation="signals-promo-subtitle-2">
                {translate("si.account-overview.signals.banner.subtitle2")}
            </StyledSignalsPromoBannerSubtitle>
            <StyledSignalsPromoBannerButton data-automation="signals-promo-button">
                <SignalsManagementButton
                    onManageClick={() =>
                        companyAnalysisTrackingService.signalEvents.trackClickOnManageSignals("default signals banner")
                    }
                />
            </StyledSignalsPromoBannerButton>
        </StyledSignalsPromoBannerContent>
    </StyledSignalsPromoBannerWrapper>
);

export default SignalsPromoBanner;
